import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxSchool from '../util/remote/ajaxSchool';

const initialState = { 
    studentId: null,
    profileInfo: null,
    walletStats: null,
    walletStatement: null,
    metaData: null,
    currentPage: 1,
    openingDate: null,
    closingDate: null,
    mounted: false,
    balanceListing: null
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const SchWalletProfileContext = createContext();

export const SchWalletProfileProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(()=>{
    if(state.studentId){
      loadProfile();
    }
  }, [state.studentId])

  useEffect(()=>{
    if(state.mounted){
      getWalletStatement();
    }
  }, [state.currentPage])


  const getStudentInfo = async () => {
    dispatch({ type: 'profileInfo', payload: null});
    const server_response  = await ajaxSchool.fetchStudentProfile(state.studentId);
    if(server_response.status === "OK"){
        dispatch({ type: 'profileInfo', payload: server_response.details});
    }else{
      dispatch({ type: 'profileInfo', payload: '404'});
    }
  };

  
  
    const getWalletStats = async()=>{
      const server_response = await ajaxSchool.fetchWalletStats({student_id: state.studentId});
      if(server_response.status === "OK"){
          dispatch({ type: "walletStats", payload: server_response.details });
      }else{
        dispatch({ type: "walletStats", payload: "00.00" });
      }
    }

    const getWalletStatement = async(refresh = false, period=null)=>{

      dispatch({ type: "mounted", payload: true });

      if (refresh) {
        dispatch({ type: "walletStatement", payload: null });
        dispatch({ type: "metaData", payload: null });
        setCurrentPage(1);
      }

      const server_response = await ajaxSchool.fetchWalletStatement(
        {
          "student_id":state.studentId,
          "opening_date": period?.opening_date || state.openingDate,
          "closing_date": period?.closing_date || state.closingDate,
          "page":refresh ? 1 : state.currentPage,
          "opening_balance": refresh? 0 : state.walletStatement?.summary?.running_opening_balance || 0
        }
      );
      if(server_response.status === "OK"){
        const newTransactions = server_response.details.data.transactions;
        dispatch({
          type: "walletStatement",
          payload: {
            transactions: refresh
            ? newTransactions
            : state.walletStatement?.transactions
            ? [...state.walletStatement.transactions, ...newTransactions]
            : newTransactions,
            summary: server_response.details.data.summary,
          },
        });

          dispatch({ type: "metaData", payload: server_response.details.meta });

      }else{
        dispatch({ type: "walletStatement", payload: "404" });
        dispatch({ type: "meta", payload: "404" });
      }
    }

  const loadProfile = async() =>{
    setCurrentPage(1);
    dispatch({ type: "walletStatement", payload: null });
    dispatch({ type: "meta", payload: null });
    await getStudentInfo();
    await getWalletStatement(true);
    await getWalletStats();
  }

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  return(
    <SchWalletProfileContext.Provider value={{
      ...state, 
      dispatch, 
      loadProfile,
      getWalletStatement,
      getWalletStats,
      setCurrentPage
      }}>
      {children}
    </SchWalletProfileContext.Provider>
  )

}

export const useSchWalletProfile = ()=>useContext(SchWalletProfileContext);

